import { useNode } from "@craftjs/core";
import { rem } from "polished";
import * as React from "react";
import type { SponsorLayout } from "src/types";
import styled from "styled-components";

import getCardMaxWidth from "@/utils/get-card-max-width";

type SponsorsListProps = {
  children: React.ReactNode;
  layout: SponsorLayout;
};

const StyledSponsorsList = styled.div<{ numOfCols: number }>`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;

  & > div {
    max-width: ${({ numOfCols }) => rem(getCardMaxWidth(numOfCols))};
  }
`;

export default function SponsorsList({ children, layout }: SponsorsListProps) {
  const {
    connectors: { connect },
  } = useNode();

  const numOfCols = layout === "golden" ? 3 : layout === "silver" ? 4 : 6;

  return (
    <StyledSponsorsList
      data-testid="sponsors-list"
      ref={connect}
      numOfCols={numOfCols}
    >
      {children}
    </StyledSponsorsList>
  );
}

SponsorsList.craft = {
  custom: {
    displayName: "Sponsors List",
  },
};
